
export const invoiceDataTransformation = (invoice) => {
    let invoiceIdList = invoice?.invoiceIdList || [];
    let invoiceData = invoiceIdList.reduce((prev, invoiceId) => {
        let merchandiseList = invoice?.invoiceMap?.[invoiceId]?.merchandiseIdList?.reduce((prev, merchandiseId) => {
            return [...prev, invoice?.merchandiseMap[merchandiseId]]
        }, [])
        return [...prev, { ...invoice?.invoiceMap[invoiceId], merchandiseList }]
    }, [])
    return invoiceData || []
}

// validate unique array for a object property
export const validateArrayObjectProperty = (dataSource, key, value) => {
    let dataSourceFiltered = dataSource.filter(elem => elem?.[key]?.trim())
    const uniqueElements = uniqueListByObjectKey(dataSource, key)
    return dataSourceFiltered?.length !== uniqueElements?.length
}

export const validateAddSupChainActorHeader = (addSupplyChainActorList,translate) => {
    const isActorOfSameRole = validateArrayObjectProperty(addSupplyChainActorList, 'role', '')
    const errorKey = `headerTab_addSupplyChainActorListError`
    const errors = isActorOfSameRole ? {
        [errorKey]: {
            msg: `${translate('ADD_SUPPLY_CHAIN_ACTOR')} :: ${translate('PARTIES')}  ::  ${translate('can_not_have_more_than_one')} ${translate('ADD_SUPPLY_CHAIN_ACTOR')} ${translate('role')} ${translate('of_same_value')}`
        }
    } : {}
    return [errorKey, errors]
}

export const validateMerchandiseActors = (actorEoriList, totalMerchandise, actorName,translate) => {
    if (totalMerchandise > 1 && actorEoriList?.length === totalMerchandise && actorEoriList?.every(itm => itm)) {
        const uniqueElements = [...new Set(actorEoriList)]
        return uniqueElements?.length < 2 ? `${translate('actorName')} : ${translate('There_should_be_at_least_one_different_EORI_number_for_all_line_items')}` : ''
    }
    return ''
}

export const validateAddSupplyChainActorItemsTab = (params) => {
    const {
        addSupplyChainActorListHeader,
        addSupplyChainActorListItems, key, tabName, tabValue, invoiceIndex, itemIndex, translate } = params
    const atShipment = uniqueListByObjectKey(addSupplyChainActorListHeader, key)
    const atItems = uniqueListByObjectKey(addSupplyChainActorListItems, key)
    let errors = {}
    const errorKeys = []
    atShipment.forEach((role) => {
        const errorKey = `invoice${invoiceIndex + 1}_lineItem${itemIndex + 1}_${tabName}_${role}`
        errorKeys.push(errorKey)
        if (atItems.includes(role)) {
            const address = `${translate('INVOICE')} 00${invoiceIndex + 1} :: ${translate('LINEITEM')} 00${itemIndex + 1} :: ${translate('PARTIES')} :: ${translate(tabValue)}} ::`
            errors = {
                ...errors,
                [errorKey]: {msg:`${address} ${translate('Role')} ${role} ${translate('should_not_be_added_at_merchandise_level_as_already_preset_at_shipment_level')}`}
            }
        }
    })
    return [errorKeys, errors]
}


function uniqueListByObjectKey(dataList, key){
    return [...new Set(dataList?.filter(elem => elem?.[key]?.trim())?.map(elem => elem?.[key]))]
}